import React from 'react'

// import { 
//   useQuery,
// } from "react-query"

// import {
//   allStats, 
// } from '../queries/statsQueries'

import GoogleAnalyticsPage from '../components/Pages/GoogleAnalyticsPage'

export default function GoogleAnalytics(){

  // const { 
  //   isLoading: isLoadingStats, 
  //   // isError, 
  //   // error, 
  //   data,
  //  } = useQuery('stats', () => allStats())

  //  const counts = !isLoadingStats ?  data.counts : []
  //  const scrapes = !isLoadingStats ?  data.stats : []

  return  <GoogleAnalyticsPage
          
           
          />
  }
